import React, { useState, useEffect } from 'react';
import {
  ReactiveBase,
  DataSearch,
  ReactiveList,
} from '@appbaseio/reactivesearch';
import EventSearchResult from './SiteSearchResult';
import { sendSiteSearchToGA4 } from '../../components/GA4';

const searchFields = [
  'facilities_name',
  'field_facility_description',
  'field_location_description',
  'title_product',
  'field_short_description',
  'theme_name',
  'field_body',
  'field_title',
  'field_description',
  'field_hero_text',
  'field_hero_title',
  'paragraphs_field_body',
  'field_link_text',
  'field_description_node',
  'field_hero_description',
  'title_node',
  'field_place',
  'field_body_text',
  'field_description_taxonomy',
  'field_hero_text_taxonomy',
  'field_hero_title_taxonomy',
  'name',
  'metatag_description_node',
  'metatag_description_product',
  'metatag_description_taxonomy',
  'metatag_keywords_node',
  'metatag_keywords_product',
  'metatag_keywords_taxonomy',
  'metatag_title_node',
  'metatag_title_product',
  'metatag_title_taxonomy',
];

const searchUrl = drupalSettings.base_url + '/node-search/';
let searchIndex;

switch (drupalSettings.active_site) {
  case 'Pyha':
    searchIndex = process.env.PYHA_ES_SITE_SEARCH_INDEX_NAME;
    break;

  case 'Luosto':
    searchIndex = process.env.LUOSTO_ES_SITE_SEARCH_INDEX_NAME;
    break;

  default:
    searchIndex = process.env.RUKA_ES_SITE_SEARCH_INDEX_NAME;
}

searchIndex += `_${drupalSettings.current_language}`;

const SiteSearch = () => {
  const [displayedResultsCount, setDisplayedResultsCount] = useState(15);
  const [totalResultsCount, setTotalResultsCount] = useState();
  const [displaySearch, setDisplaySearch] = useState(false);
  const [query, setQuery] = useState('');
  const dataLayer = window.dataLayer;

  function toggleDisplaySearch() {
    // Displays search overlay and hides content below.
    let footerElement = document.getElementsByClassName('main')[0];
    let mainElement = document.getElementsByClassName('footer')[0];
    if (displaySearch) {
      setDisplaySearch(false);
      footerElement.style.display = 'block';
      mainElement.style.display = 'block';
    } else {
      setDisplaySearch(true);
      footerElement.style.display = 'none';
      mainElement.style.display = 'none';
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (query.length > 0) {
        sendSiteSearchToGA4(dataLayer, query, totalResultsCount);
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [query, totalResultsCount]);

  return (
    <ReactiveBase
      app={searchIndex}
      url={searchUrl}
      headers={{
        token: `${process.env.RUKA_ES_AUTH_TOKEN}`,
      }}
      theme={{
        typography: {
          fontFamily: 'helvetica neue,arial,sans-serif',
        },
        colors: {
          textColor: '#223',
          primaryColor: '#223',
        },
      }}
    >
      {displaySearch ? (
        <button
          onClick={toggleDisplaySearch}
          className="site-search__toggle site-search__toggle--close"
        >
          <span className="visually-hidden">
            {Drupal.t('Close search bar')}
          </span>
        </button>
      ) : (
        <button
          onClick={toggleDisplaySearch}
          className="site-search__toggle site-search__toggle--open"
        >
          <span className="visually-hidden">{Drupal.t('Open search bar')}</span>
        </button>
      )}
      {displaySearch && (
        <div className="site-search__inner-wrapper">
          <h1 className="site-search__title">
            {Drupal.t('Search from the site')}
          </h1>
          <div className="site-search__form">
            <div className="site-search__form__close-wrapper">
              <button
                onClick={toggleDisplaySearch}
                className="site-search__form__close"
              >
                {Drupal.t('Close search')}
              </button>
            </div>

            <DataSearch
              componentId="searchbox"
              dataField={searchFields}
              placeholder={Drupal.t('Keyword')}
              className="site-search__form__searchbox"
              autosuggest={false}
              onValueChange={(value) => {
                setQuery(value);
              }}
              autoFocus
            />
          </div>
          {query.length > 2 && (
            <div className="site-search__results-wrapper">
              <ReactiveList
                componentId="results"
                showResultStats={true}
                size={15}
                scrollOnChange={false}
                loader=" "
                react={{
                  and: ['searchbox'],
                }}
                renderNoResults={() => (
                  <div className="site-search__result-count">
                    {Drupal.t('No results')}
                  </div>
                )}
                renderResultStats={(stats) => (
                  <div className="site-search__result-count">
                    {`${stats.numberOfResults} ${Drupal.t('results')}`}
                  </div>
                )}
                render={({ data }) => (
                  <div className="site-search__results-inner-wrapper">
                    {setTotalResultsCount(data.length)}
                    {data.slice(0, displayedResultsCount).map((item) => (
                      <EventSearchResult
                        key={item.nid}
                        title={
                          item.title_node || item.title_product || item.name
                        }
                        url={item.url}
                        description={
                          item.field_description_node ||
                          item.field_short_description ||
                          item.field_description ||
                          item.field_description_taxonomy ||
                          item.field_hero_description
                        }
                        type={
                          item.status_product
                            ? 'product'
                            : item.type || 'default'
                        }
                      />
                    ))}
                  </div>
                )}
              />
              {totalResultsCount > displayedResultsCount && (
                <div className="site-search__showmore-wrapper">
                  <button
                    className="site-search__showmore button"
                    onClick={() =>
                      setDisplayedResultsCount(displayedResultsCount + 15)
                    }
                  >
                    {Drupal.t('Show more')}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </ReactiveBase>
  );
};

export default SiteSearch;
